import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Terms from "@/pages/Terms";

export const Route = createFileRoute("/_public/terms")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Terms of Service \u2014 Modern Fence Install", "Terms governing the use of modernfenceinstall.com and the purchase of fence installation services from Modern Fence Install LLC.", "/terms", false),
  component: Terms,
});
